import { useState } from 'react';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import Loading from 'uI/Loading/Loading';

import { verifiedCodeUVM } from 'store/verified-actions';

import classes from './Verified.module.css';

const Verified = () => {
  const [code, setCode] = useState('');
  const [load, setLoad] = useState(false);
  const [userInfo, setUserInfo] = useState('');
  console.log('🚀 ~ Verified ~ userInfo:', userInfo);

  const changeInputHandler = event => {
    setCode(event.target.value);
  };

  const checkCodeHandler = () => {
    setLoad(true);
    (async () => {
      setUserInfo(await verifiedCodeUVM(code));
      setLoad(false);
    })();
  };

  return (
    <Paper className={classes.verifiedContainer} elevation={1}>
      <p className={classes.title}>
        Centro de Verificación Certificaciones MAYAHII
      </p>
      <p className={classes.description}>
        Escriba en la casilla el código verificador del diploma
      </p>
      <TextField
        label="Código"
        className={classes.textField}
        placeholder="Código"
        value={code}
        variant="outlined"
        onChange={changeInputHandler}
        size="small"
      />
      <div className={classes.btnContainer}>
        {!load ? (
          <Button
            onClick={checkCodeHandler}
            className={classes.validateBtn}
            disabled={!code}
          >
            Validar
          </Button>
        ) : (
          <Loading />
        )}
      </div>
      {userInfo == 'error' ? (
        <p className={classes.error}>No se encontraron resultados</p>
      ) : (
        userInfo.certification_name && (
          <>
            <p className={classes.item}>{userInfo.full_name}</p>
            <p className={classes.item}>
              <strong>Código: </strong>
              {userInfo.code}
            </p>
            <p className={classes.item}>
              <strong>Diploma: </strong>
              {userInfo.certification_name}
            </p>
            <p className={classes.item}>
              <strong>Nivel: </strong>
              {userInfo.level_diploma}
            </p>
            <p className={classes.item}>
              <strong>Fecha: </strong>
              {userInfo.end_date}
            </p>
          </>
        )
      )}
    </Paper>
  );
};

export default Verified;
